import { destroyElement, toCSS } from 'belter'
import { EVENT } from 'zoid/dist/zoid.frameworks'

const CLASS = {
  VISIBLE: 'zoid-visible',
  INVISIBLE: 'zoid-invisible',
}

export default ({
  uid,
  frame,
  prerenderFrame,
  doc,
  props,
  event,
  dimensions,
}) => {
  const { height } = dimensions

  if (!frame || !prerenderFrame) {
    return
  }

  frame.setAttribute('allowfullscreen', '')

  const div = Object.assign(doc.createElement('div'), {
    id: uid,
    className: 'ps-mbo-modal--backdrop',
    onclick: () => props.handleCloseDialog(frame, uid)
  })

  const dialogDiv = Object.assign(doc.createElement('div'), {
    className: 'ps-mbo-modal--dialog',
  })

  const style = doc.createElement('style')
  if (props.cspNonce) {
    style.setAttribute('nonce', props.cspNonce)
  }

  function getMinWidth() {
    switch (props.size) {
      case 'sm':
        return '508px'
      case 'md':
      default:
        return '862px'
      case 'lg':
        return '1100px'
    }
  }

  style.appendChild(
    doc.createTextNode(`
      .ps-mbo-modal--backdrop {
        padding: 16px;
        z-index: 9999;
        position: fixed;
        top: 0px;
        height: 100vh;
        width: 100%;
        background-color: rgb(0 0 0 / 0.4);
        --tw-backdrop-blur: blur(4px);
        backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transition-property: opacity;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 100ms;
      }

      .ps-mbo-modal--dialog > iframe {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        transition: opacity .2s ease-in-out;
      }
  
      #${uid} iframe.${CLASS.INVISIBLE} {
          opacity: 0;
      }
      #${uid} iframe.${CLASS.VISIBLE} {
          opacity: 1;
      }
  
      .ps-mbo-modal--dialog {
        display: flex;
        position: relative;
        height: ${height};
        max-width: 100%;
        flex-direction: column;
        align-items: flex-start;
        overflow: auto;
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 100ms;
        border-radius: 0px;
        border-width: 0px;
        --tw-border-opacity: 1;
        border-color: #DDDDDD;
        --tw-bg-opacity: 1;
        background-color: #FFFFFF;
        --tw-drop-shadow: drop-shadow(0 25px 25px rgb(0 0 0 / 0.15));
        filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
        width: 100%;
      }
  
      @media (min-width:640px) {
        .ps-mbo-modal--dialog {
          height: ${height};
          max-width: ${getMinWidth()};
          border-width: 1px;
        }
      }`),
  )

  div.appendChild(style)
  div.appendChild(dialogDiv)
  dialogDiv.appendChild(prerenderFrame)
  dialogDiv.appendChild(frame)

  prerenderFrame.classList.add(CLASS.VISIBLE)
  frame.classList.add(CLASS.INVISIBLE)

  const disableBodyScroll = () => {
    const body = document.querySelector('body') as HTMLElement
    body.style.overflow = 'hidden'
  }

  const enableBodyScroll = () => {
    const body = document.querySelector('body') as HTMLElement
    body.style.overflow = 'auto'
  }

  event.on(EVENT.CLOSE, () => {
    enableBodyScroll()
  })

  event.on(EVENT.RENDERED, () => {
    disableBodyScroll()
    prerenderFrame.classList.remove(CLASS.VISIBLE)
    prerenderFrame.classList.add(CLASS.INVISIBLE)

    frame.classList.remove(CLASS.INVISIBLE)
    frame.classList.add(CLASS.VISIBLE)

    setTimeout(() => {
      destroyElement(prerenderFrame)
    }, 1)
  })

  event.on(EVENT.RESIZE, ({ width: newWidth, height: newHeight }) => {
    if (typeof newWidth === 'number') {
      dialogDiv.style.width = toCSS(newWidth)
    }

    if (typeof newHeight === 'number') {
      dialogDiv.style.height = toCSS(newHeight)
    }
  })

  return div
}
